import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'reactstrap';
import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import ReactFileReader from 'react-file-reader';
import {apiRequest} from '../../utils/request';
import FileSaver from 'file-saver';
import 'react-table/react-table.css';
import ReactTable from 'react-table';

class AttachmentsView extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      attachments: props.attachments ? props.attachments : [],
      selectedAttachment: null,
    };

    this.handleAttachmentFieldChange = this.handleAttachmentFieldChange.bind(this);
    this.handleSaveAttachment = this.handleSaveAttachment.bind(this);
    this.validateAttachment = this.validateAttachment.bind(this);
    this.handleCancelAttachment = this.handleCancelAttachment.bind(this);
    this.handleNewAttachment = this.handleNewAttachment.bind(this);
    this.handleAttachmentDelete = this.handleAttachmentDelete.bind(this);
    this.handleSelectAttachment = this.handleSelectAttachment.bind(this);
    this.getColumns = this.getColumns.bind(this);
  }

  handleAttachmentFieldChange(e) {
    if (e.base64 && e.base64 != '' && e.fileList.length == 1 && e.fileList[0].name != '') {
      if (e.fileList[0].size > 5000000) {
        toastr.error('File must be less than 5 Mb');
        this.setState({
          selectedAttachment: {
            ...this.state.selectedAttachment,
            fileContents: '',
            fileName: ''
          }
        });
      } else {
        this.setState({
          selectedAttachment: {
            ...this.state.selectedAttachment,
            fileContents: e.base64,
            fileName: e.fileList[0].name
          }
        });
      }
    } else {
      toastr.warning('Bad file');
    }
  }

  handleSaveAttachment() {
    let added = false;
    let attachments = [...this.state.attachments].map(x => {
      let returnVal = x;
      if (returnVal.id == this.state.selectedAttachment.id) {
        added = true;
        return this.state.selectedAttachment;
      }
      return returnVal;
    });
    if (!added) {
      attachments = [...this.state.attachments, this.state.selectedAttachment];
    }
    if(this.props.onChange){
      this.props.onChange(attachments);
    }
    this.setState({attachments, selectedAttachment: null});
  }

  validateAttachment(){
    let {selectedAttachment} = this.state;
    if(this.state.selectedAttachment){
      if(selectedAttachment.fileName.trim() == ''){
        return {valid: false, error: ''};
      }
    }
    return {valid: true, error: ''};
  }

  handleCancelAttachment(){
    this.setState({selectedAttachment: null});
  }

  handleNewAttachment() {
    let count = this.state.attachments.reduce((a, b) => {
      return b.id < 0 ? a + 1 : a;
    }, 0);
    this.setState({selectedAttachment: {id: (-1 - count), fileName: ''}});
  }

  handleAttachmentDelete(c){
    let attachments = this.state.attachments.filter(x => x.id != c.id);
    if(this.props.onChange){
      this.props.onChange(attachments);
    }
    this.setState({attachments});
  }

  handleSelectAttachment(ev, attachment) {
    ev.preventDefault();
    apiRequest(`/api/attachments/${attachment.id}`)
      .then(x => {
        if (x.error || x.data.Message) {
          toastr.error(`Error while fetching attachment, error: ${x.error ? x.error : x.data.Message}`);
        } else {
          fetch(x.data.fileContents)
            .then(res => res.blob())
            .then(blob => FileSaver.saveAs(blob, x.data.fileName));
        }
      });
  }

  getColumns() {
    return [
      {
        id: 'fileName',
        accessor: c => (c.id > 0 ?
            <a href="#" onClick={(e) => this.handleSelectAttachment(e, c)}>{c.fileName}</a>
            :
            <span>{c.fileName} (pending save)</span>),
        Header: 'Filename',        
      }, 
      {
        id: 'updated',
        Header: 'Updated',
        accessor: c => c.id > 0 ? moment(c.updatedDate ? c.updatedDate : c.createdDate).format("DD/MM/YYYY h:mm:ss a") : '',
      },
      {
        accessor: 'updatedBy',
        Header: 'Updated By',
      },
      {
        id: 'action',
        Header: '',
        accessor: c => (<Button color="danger" onClick={() => this.handleAttachmentDelete(c)}><i className="fa fa-times"/></Button>),
        maxWidth: 60,
      }
    ];
  }

  render() {
    const isValidAttachment = this.validateAttachment();
    let {attachments, selectedAttachment} = this.state;
    return (this.props.visible || this.props.visible === undefined) ? (
        <div style={{marginTop: '20px', marginBottom: '20px'}}>
          <div className="form-group row">
            <div className={"col-12"}>
              <h6>
                {this.props.headerText ? this.props.headerText : 'Notes'}&nbsp;<Button color="success"
                                                                                       onClick={this.handleNewAttachment}><i
                  className="fa fa-plus"/>&nbsp;&nbsp;Add attachment</Button>
              </h6>
            </div>
          </div>

          {selectedAttachment ?
              (<div className="form-group row">
                <div className="col-12 col-md-12 col-xl-12">
                  <div className="form-horizontal">
                    <div className="form-group row">
                      <div className="col-md-2">
                        <ReactFileReader base64 multipleFiles={false}
                                         handleFiles={this.handleAttachmentFieldChange}>
                          <button className="btn">Upload</button>
                        </ReactFileReader>
                      </div>
                      <div
                          className="col-md-10">{selectedAttachment.fileName ? selectedAttachment.fileName : 'Select file'}</div>
                    </div>
                    <div className="form-group row">
                      <div className="col-md-8">
                        {isValidAttachment.valid ?
                            <Button color="primary" onClick={this.handleSaveAttachment}
                                    style={{marginRight: '10px'}}><i
                                className="fa fa-check"/>&nbsp;
                            </Button> :
                            <span className="text-danger">{isValidAttachment.error}</span>
                        }
                        <Button color="seconday" onClick={this.handleCancelAttachment}><i
                            className="fa fa-mail-reply"/>&nbsp;
                        </Button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>)
              :
              (<ReactTable
                  sortable={false}
                  filterable={false}
                  showPagination={false}
                  data={attachments}
                  columns={this.getColumns()}
                  minRows={3}
              />)}
        </div>) : null;
  }
}
AttachmentsView.propTypes = {
  attachments: PropTypes.array.isRequired,
  onChange: PropTypes.func,
  headerText: PropTypes.string,
  visible: PropTypes.bool,
};

AttachmentsView.defatultProps = {
  attachments: [],
  headerText: 'Attachments'
};

export default AttachmentsView;
